export default __webpack_public_path__ + "static/media/enlogo.e76a3dd2.png";